import type { ColumnDef } from "@tanstack/react-table"
import { format } from "date-fns"

import { AccessManagementActionsCell } from "./actions-cell"
export const accessManagementColumns: ColumnDef<User>[] = [
  {
    accessorKey: "name",
    header: "Nome",
    enableHiding: false,
    cell: ({ row }) => <div>{row.original.fullName}</div>,
  },
  {
    accessorKey: "email",
    header: "E-mail",
    cell: ({ row }) => <div>{row.original.email}</div>,
  },
  {
    accessorKey: "group",
    header: "Permissões",
    cell: ({ row }) => (
      <div>
        {row.original.groups && row.original.groups.length > 0
          ? row.original.groups.join(", ")
          : "-"}
      </div>
    ),
  },
  {
    accessorKey: "createdDate",
    header: "Data de criação",
    cell: ({ row }) => {
      const createdAt = row.original.createdAt
      const formatted = createdAt
        ? format(new Date(createdAt), "dd/MM/yyyy")
        : "-"
      return <div>{formatted}</div>
    },
  },
  {
    accessorKey: "actions",
    enableHiding: false,
    header: "",
    cell: ({ row }) => (
      <div className="flex justify-end p-1">
        <AccessManagementActionsCell user={row.original} />
      </div>
    ),
  },
]
